/*
* Global rich text styling when not passed into the RichTextWrapper
*/
export default class RichTextStyling { };

RichTextStyling.DEFAULT = {
    b: { font: "bold 40px 'Roboto'" },
    i: { font: "italic 40px 'Roboto'" },
    bi: { font: "bold italic 40px 'Roboto'" },
    a: {
        font: "40px 'Roboto'",
        hover: {
            color: "#1F40E6"
        }
    },
    _default: { // _default, because 'default' is a reserved keyword
        font: "40px 'Roboto'"
    }
}

RichTextStyling.defaultWithCustomSize = function (size = "40") {
    return {
        b: { font: "bold " + size + "px 'Roboto'" },
        i: { font: "italic " + size + "px 'Roboto'" },
        bi: { font: "bold italic " + size + "px 'Roboto'" },
        a: {
            font: size + "px 'Roboto'",
            hover: {
                color: "#1F40E6"
            }
        },
        _default: {
            font: size + "px 'Roboto'"
        }
    };
}

RichTextStyling.defaultForFont = function (fontName) {
    return {
        b: { font: "bold " + fontName },
        i: { font: "italic " + fontName },
        bi: { font: "bold italic " + fontName },
        a: {
            font: fontName,
            color: "#1F40E6",
            hover: {
                color: "#5C7EF7"
            }
        },
        _default: {
            font: fontName
        }
    };
}

RichTextStyling.whiteColorForFont = function (fontName) {
    return {
        b: { font: "bold " + fontName },
        i: { font: "italic " + fontName },
        bi: { font: "bold italic " + fontName },
        a: {
            font: fontName,
            color: "#FFF",
            hover: {
                color: "#FFF"
            }
        },
        _default: {
            font: fontName
        }
    };
}

